import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import axios from '@/apiClient';
import { GroupTypes } from '@/interfaces/enums';
import ClientChat from '@/models/clientChat';
import Ingredient from '@/models/ingredient';
import Product from '@/models/product';
import TakeAway from '@/models/takeAway';
import { AxiosResponse } from 'axios';
import getClientChatTransformer from './transformers/clients/clientChatTransformer';
import getClientDetailsTransformer from './transformers/clients/clientDetailsTransformer';
import getClientsTransformer from './transformers/clients/clientsTransformer';

export default {
  async fetchClients(): Promise<any> {
    return window.axios.get('/clients/list', {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      transformResponse: getClientsTransformer(),
    });
  },
  async createClient(client: any) {
    return window.axios.post('/clients/create', client, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async editClient({ id, editedFields }: any): Promise<any> {
    return window.axios.patch(`/clients/edit/${id}`, editedFields, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async removeClient(clientId: string) {
    return window.axios.delete(`/clients/remove/${clientId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async fetchClientDetails(clientId: string): Promise<{ orders: TakeAway[], chat: ClientChat }> {
    return axios.get(`/clients/details/${clientId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      transformResponse: getClientDetailsTransformer(),
    })
      .then(({ data }: AxiosResponse<{ orders: TakeAway[], chat: ClientChat }>) => data);
  },
  async fetchClientOrderStats(clientId: string): Promise<any> {
    return axios.get(`/client/statistics/${clientId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      // transformResponse: getClientDetailsTransformer()
    })
      .then(({ data }: AxiosResponse) => data);

    return {
      performance: {
        totalOrders: 11,
        averageTotalSpent: 43,
        averageReview: 4.32,
      },
      popularProducts: [
        Product.createFromRequest(<any>{
          'id': 'ZM8e1eHR3zKZ',
          'priority': 1,
          'title': 'Гриль-кебаб стандартный',
          'image': {
            'id': 'Buz2zS7toQ3B',
            'original': {
              'id': 'YERXyF4D0FqG',
              'path': '/uploads/originals/7adb4762beca7e2282f8b6c848a1902d.png',
            },
            'options': {
              'x': 0,
              'y': 0,
              'width': 899.9999999999999,
              'height': 899.9999999999999,
              'scaleX': 1,
              'scaleY': 1,
            },
            'path': '/uploads/cropped/6df8ee812e229e9ceb819643a896a9c3.png',
          },
          'description': 'Филе птицы, аккуратно насаживаем на вертел, обжариваем его в течении 10 - 15\nминут и срезаем готовое мясо тонким слоем.  Берем тонкий лаваш, разворачиваем его и равномерно распределяем по нему соус (чесноч. Карри). Обжаренное мясо, солим, перчим и выкладываем на лаваш, прямо на соус.  Белокочанную капусту, нарезаем соломкой. Огурец соленый брусочком томат\nполукольцами. Нарезанные овощи добавляем сверху. Лаваш заворачиваем полностью\nпокрывая начинку. Сворачиваем лаваш с обеих сторон подобно рулету. Готовый гриль - \nкебаб кладем на контактный гриль, выдерживаем в течении 2 - 3 мин, с обеих сторон. Температура подачи блюда – не менее 65°С',
          'weight': '550 гр.',
          'cost': 7,
          'isShow': false,
          'isShowInPos': true,
          'isFavorite': false,
          'groups': [
            {
              'id': 'gvAH70nyTpHd',
              'name': null,
              'priority': 0,
              'type': GroupTypes.REQUIRED,
              'ingredients': [],
            },
            {
              'id': 'X5ZFCZM0XuCH',
              'name': null,
              'priority': 0,
              'type': GroupTypes.OPTIONAL,
              'ingredients': [
                {
                  'id': 'CAkSKXhO09iN',
                  'name': 'Соус чесночный старый',
                  'description': '',
                  'image': {
                    'id': 'O2KWImCkzgTi',
                    'original': {
                      'id': 'e8Z1A9MGRrMp',
                      'path': '/uploads/originals/a21311e5fef94a862bc0d5c98d28e169.jpg',
                    },
                    'options': {
                      'x': 17.639534883720916,
                      'y': 17.639534883720916,
                      'width': 563.7209302325582,
                      'height': 563.7209302325582,
                      'scaleX': 1,
                      'scaleY': 1,
                    },
                    'path': '/uploads/ingredients/9b8ddd0557c2a600c8f61eba4f5eec16.jpeg',
                  },
                  'unit': 'GRAM',
                  'projectIngredient': {
                    'id': 'jBHFfSoIyLWR',
                  },
                  'count': 1,
                  'cost': 0,
                  'unitCount': 0,
                  'posCode': 1002,
                },
                {
                  'id': 'oUtPETqyaxP1',
                  'name': 'Соус карри старый',
                  'description': '',
                  'image': {
                    'id': '46C1y7QmaGtI',
                    'original': {
                      'id': 'DdxwWokHJdlj',
                      'path': '/uploads/originals/7a032e1b21a5b12324f4b700ed3d0db7.png',
                    },
                    'options': {
                      'x': 33.14447592067989,
                      'y': 9.63172804532578,
                      'width': 334.8441926345609,
                      'height': 334.8441926345609,
                      'scaleX': 1,
                      'scaleY': 1,
                    },
                    'path': '/uploads/cropped/2e420c7cc192ff63690a8e1c2935effe.png',
                  },
                  'unit': 'GRAM',
                  'projectIngredient': {
                    'id': '8ZbFhcBHzRTk',
                  },
                  'count': 1,
                  'cost': 0,
                  'unitCount': 0,
                  'posCode': 1003,
                },
                {
                  'id': 'A0vkDJhQ7jUC',
                  'name': 'Соус острый старый',
                  'description': '',
                  'image': {
                    'id': 'QNYSGO3DTMI9',
                    'original': {
                      'id': 'uOzBe2OiGyNF',
                      'path': '/uploads/originals/31a506f7aee33d05159aa53d1983ace5.png',
                    },
                    'options': {
                      'x': 14.75899850024996,
                      'y': 14.75899850024996,
                      'width': 370.4820029995,
                      'height': 370.4820029995,
                      'scaleX': 1,
                      'scaleY': 1,
                    },
                    'path': '/uploads/ingredients/f3fa91b7ebc4e57095c63386dfb48225.png',
                  },
                  'unit': 'MILLILITER',
                  'projectIngredient': {
                    'id': '6jc4MUTEnup4',
                  },
                  'count': 1,
                  'cost': 0,
                  'unitCount': 0,
                  'posCode': 1004,
                },
                {
                  'id': 'RfDmkE6Kh5Ce',
                  'name': 'Сыр старый',
                  'description': '',
                  'image': {
                    'id': '4ktZuM9Ft4D8',
                    'original': {
                      'id': 'nyq05iNnvtnW',
                      'path': '/uploads/originals/288ff152846c4732153602aaa04445b2.png',
                    },
                    'options': {
                      'x': 0,
                      'y': 0,
                      'width': 500,
                      'height': 500,
                      'scaleX': 1,
                      'scaleY': 1,
                    },
                    'path': '/uploads/ingredients/cd2d5eac913a59274fe6bbc869e4d009.png',
                  },
                  'unit': 'UNIT',
                  'projectIngredient': {
                    'id': 'B6175IyqvH6f',
                  },
                  'count': 1,
                  'cost': 0,
                  'unitCount': 0,
                  'posCode': 1005,
                },
                {
                  'id': 'HzOYJYty6gtg',
                  'name': 'Лук старый старый',
                  'description': '',
                  'image': {
                    'id': 'lNurpE9OUn5i',
                    'original': {
                      'id': 'QmZ8d8XgHeSg',
                      'path': '/uploads/originals/c532a5be5c5025bf1596f0e5caa801ac.jpg',
                    },
                    'options': {
                      'x': 205,
                      'y': 0,
                      'width': 1094.9999999999998,
                      'height': 1094.9999999999998,
                      'scaleX': 1,
                      'scaleY': 1,
                    },
                    'path': '/uploads/ingredients/e5706dbf89dc972b190f35032b085703.jpeg',
                  },
                  'unit': 'GRAM',
                  'projectIngredient': {
                    'id': 'Cqa6HvDvXAQu',
                  },
                  'count': 1,
                  'cost': 0,
                  'unitCount': 0,
                  'posCode': 1006,
                },
                {
                  'id': 'coLwHS3ijUWG',
                  'name': 'Халапеньо старый',
                  'description': '',
                  'image': {
                    'id': '38f4lQSXQvGL',
                    'original': {
                      'id': 'iAK6eFyjjK4Q',
                      'path': '/uploads/originals/a5cb83e5b5eb7abcc847bc2f5d679fc2.jpg',
                    },
                    'options': {
                      'x': -8.207589356964853e-14,
                      'y': -4.1037946784824265e-14,
                      'width': 700,
                      'height': 700,
                      'scaleX': 1,
                      'scaleY': 1,
                    },
                    'path': '/uploads/ingredients/b27b8ade0d6e3ee270a29e4ce9f9228c.jpeg',
                  },
                  'unit': 'GRAM',
                  'projectIngredient': {
                    'id': 'FCu1O9ROKKj1',
                  },
                  'count': 1,
                  'cost': 0,
                  'unitCount': 0,
                  'posCode': 1007,
                },
              ],
            },
          ],
          'category': {
            'id': 'JKoNK7tZb8Oa',
            'name': 'Блюда',
          },
          'projectProduct': {
            'id': 'kpVVpltTpKWE',
          },
        }),
      ],
      popularIngredients: [
        Ingredient.createFromRequest(<any>{
          description: '',
          id: 'HzOYJYty6gtg',
          image: {
            id: 'lNurpE9OUn5i',
            options: {
              x: 205,
              y: 0,
              width: 1095,
              height: 1095,
              scaleX: 1,
              scaleY: 1,
            },
            original: {
              id: 'QmZ8d8XgHeSg',
              path: '/uploads/originals/c532a5be5c5025bf1596f0e5caa801ac.jpg',
            },
            path: '/uploads/ingredients/e5706dbf89dc972b190f35032b085703.jpeg',
          },
          name: 'Лук старый старый',
          projectIngredient: {
            id: 'Cqa6HvDvXAQu',
          },
          unit: 'GRAM',
        }),
      ],
    };
  },
  async fetchClientChat(clientId: string) {
    return window.axios.get(`/client/chat/${clientId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      transformResponse: getClientChatTransformer(),
    });
  },
  async makeClientNormal(clientId: string) {
    return window.axios.patch(`/clients/normal/${clientId}`, null, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async makeClientBanned(clientId: string) {
    return window.axios.patch(`/clients/banned/${clientId}`, null, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async makeClientFavorite(clientId: string) {
    return window.axios.patch(`/clients/favorite/${clientId}`, null, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
    });
  },
  async searchClientByClientCredentials({ name, phone }: any): Promise<any> {
    return window.axios.get(`/clients/search?name=${name}&phone=${phone}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      transformResponse: getClientsTransformer(),
    });
  },
  async createMessage(payload: any): Promise<any> {
    return axios.post(
      `/client-chat/message/create/${payload.client.id}`,
      {
        text: payload.message,
      },
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
      },
    )
      .then(({ data }: any) => data);
  },
  async readMessages(clientId: string): Promise<any> {
    return window.axios.head(
      `/client-chat/message/read/${clientId}`,
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
      },
    );
  },
  async editMessage(message: {id: string, text: string }): Promise<any> {
    return window.axios.patch(
      `/client/message/edit/${message.id}`,
      {
        text: message.text
      },
      {
        transformRequest: [
          ...getClientApiRequestTransformer,
          ...getSocketIdRequestTransformer,
        ],
      },
    );
  },
};
